import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=19153e27&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"
import style0 from "./EmailList.vue?vue&type=style&index=0&id=19153e27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19153e27",
  null
  
)

export default component.exports